import { render } from "./CrudQuestions.vue?vue&type=template&id=07306a0e"
import script from "./CrudQuestions.vue?vue&type=script&lang=js"
export * from "./CrudQuestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__